import { useTranslation } from "react-i18next";
import { TOTAL_STEPS } from "../wizard-config";

// "STEP X OF 10" eyebrow + title + subtitle, shared by every step body.
const StepHeading = ({ current, title, subtitle }) => {
  const { t } = useTranslation("auth");
  return (
    <header className="step-heading">
      <span className="eyebrow">
        {t("onboardingWizard.stepLabel", { current, total: TOTAL_STEPS })}
      </span>
      <h2>{title}</h2>
      {subtitle ? <p>{subtitle}</p> : null}
    </header>
  );
};

export default StepHeading;
